import template from './changelog.html';
import { ChangelogController } from './changelog.controller';
import './changelog.scss';

export const changelogComponent = {
  name: 'changelog',
  restrict: 'E',
  template,
  controller: ChangelogController,
  controllerAs: 'vm',
  bindings: {},
};



// WEBPACK FOOTER //
// ./src/app/components/changelog/changelog.component.js